module.exports = __webpack_public_path__ + "meestportalsmall.png";